import { Component, Host, h, Prop } from '@stencil/core';
import { toValUnit } from './../../../utils/utils';

@Component({
  tag: 'afs-flex-wrapper',
  styleUrl: 'afs-flex-wrapper.css',
  shadow: true,
})
export class AfsFlexWrapper {

  @Prop() slotHeight : string = '4rem';
  @Prop() slotMargin : string = '1rem';
  @Prop() direction : 'row' | 'column' | 'row-reverse' | 'column-reverse' = 'row';
  @Prop() justifyContent : string = 'center';
  @Prop() alignItems : string = "center";
  @Prop() wrap : string = 'wrap';

  render() {
    return (
      <Host style={{
        '--slot-height': toValUnit(this.slotHeight),
        '--slot-margin': toValUnit(this.slotMargin),
        flexDirection : this.direction,
        justifyContent: this.justifyContent,
        alignItems: this.alignItems,
        flexWrap: this.wrap,
      }}>
        <slot></slot>
      </Host>
    );
  }

}
